import { FC } from 'react';
import List, { ListProps } from '../Search/List';

export interface SearchViewProps {
  listGroups: Array<{
    title: string;
    lists: ListProps[];
  }>;
  showEmpty?: boolean;
}

const SearchView: FC<SearchViewProps> = ({ listGroups, showEmpty = false }) => (
  <>
    {listGroups
      .filter(
        ({ lists }) =>
          !showEmpty && lists.some(({ data: { length } }) => length > 0),
      )
      .map(({ title, lists }) => (
        <div key={title}>
          <h3>{title}</h3>
          {lists
            .filter(({ data: { length } }) => showEmpty || length > 0)
            .map((list, idx) => (
              <List key={idx} {...list} />
            ))}
        </div>
      ))}
  </>
);

export default SearchView;
